module.exports = new __parcel__URL__("doom-3.d9f27418.jpg").toString();